module.exports = __webpack_public_path__ + "img/chanpingjingli.0633002a.png";